import { ConfigProvider, theme } from 'antd';
import enUS from 'antd/locale/en_US';
import viVN from 'antd/locale/vi_VN';
import zhCN from 'antd/locale/zh_CN';
import { Suspense, lazy } from 'react';
import { useTranslation } from 'react-i18next';
import './App.css';
import AppLoading from './AppLoading';
import { useLocaleStore } from './locale';

const AppRouter = lazy(() => import('./AppRouter'));

const localeMap = {
  'zh-CN': zhCN,
  'en-US': enUS,
  'vi-VN': viVN
}

function App() {

  const locale = useLocaleStore(state => state.locale);

  const { t } = useTranslation();

  return (
    <ConfigProvider locale={localeMap[locale]} theme={{
      algorithm: [theme.compactAlgorithm]
    }}>
      <Suspense fallback={(
        <AppLoading tip={t("大圣设计欢迎您") + "!"} />
      )}>
        <AppRouter />
      </Suspense>
    </ConfigProvider>
  );
}

export default App;
